const libPictView = require('pict-view');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-BridgesPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */
/** @typedef {(bridge: any) => void} BridgeSelectionCallback */

class HeadlightPaneBridges extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.dataLakeBridgeClient = this.fable.instantiateServiceProvider('RestClient', 'LakeBridgeClient');

		this.CurrentBridgeSearchResults = [];
		this.CurrentSearchFiltersCount = 0;
		this.StateAbbreviation = '';
		/**
		 * @type {BridgeSelectionCallback}
		 * @param {any} bridge
		 */
		this.bridgeSelectionCallback = (bridge) =>
		{
			// optional callback function to run when a bridge is selected
		};

		this.currentStart = 0;
		this.pageSize = 100;
	}

	/**
	 * This function is used to handle the search for bridges.
	 * @param {Event} event - The event that triggered the search
	 * @return {boolean} - Always returns false
	 */
	handleBridgeSearch(event)
	{
		if (event)
		{
			event.preventDefault();
		}
		// add the loading spinner on the button when the action is being performed
		this.pict.ContentAssignment.addClass('#BridgeSearch-SearchButton', 'is-loading');
		// simulate that data is loading in the results table
		this.pict.views.HeadlightPanels.addLoadingSkeletonRows('BridgePanel-SearchResults-Container', this.pageSize, '2rem');
		// toggle the filter panel closed
		this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('BridgeSearchFilters', 'close');

		const tmpCounty = String(this.pict.ContentAssignment.readContent('#BridgesSearchCounty'));

		if (tmpCounty.trim().length > 0)
		{
			this.CountySearch = tmpCounty.trim();
		}
		else
		{
			this.CountySearch = false;
		}

		const tmpStructureNumber = String(this.pict.ContentAssignment.readContent('#BridgesSearchStructureNumber'));

		if (tmpStructureNumber.trim().length > 0)
		{
			this.StructureSearch = tmpStructureNumber.trim();
		}
		else
		{
			this.StructureSearch = false;
		}

		const tmpFacilityCarried = String(this.pict.ContentAssignment.readContent('#BridgesSearchFacilityCarried'));

		if (tmpFacilityCarried.trim().length > 0)
		{
			this.FacilityCarriedSearch = tmpFacilityCarried.trim();
		}
		else
		{
			this.FacilityCarriedSearch = false;
		}

		const tmpFeatureIntersected = String(this.pict.ContentAssignment.readContent('#BridgesSearchFeatureIntersected'));

		if (tmpFeatureIntersected.trim().length > 0)
		{
			this.FeatureIntersectedSearch = tmpFeatureIntersected.trim();
		}
		else
		{
			this.FeatureIntersectedSearch = false;
		}

		const tmpYearBuilt = String(this.pict.ContentAssignment.readContent('#BridgesSearchYearBuilt'));

		if (tmpYearBuilt.trim().length > 0)
		{
			this.YearBuiltSearch = tmpYearBuilt.trim();
		}
		else
		{
			this.YearBuiltSearch = false;
		}

		this.currentStart = 0;

		this.loadBridgeData();
		return false;
	}

	/**
	 * This function is used to load the bridges from the lake.
	 * @return {void}
	 */
	loadBridgeData()
	{
		// get the state filter for the user
		this.pict.providers.ConfigurationProvider.getConfigurationByScope(this.AppData?.CurrentUser?.CustomerID,
		(pResult) =>
		{
			// set the state abbreviation for the user (if it exists)
			this.StateAbbreviation = pResult?.StateAbbreviation;
			// set the search filters to pass to the provider
			const tmpFilters = {
				County: this.CountySearch,
				StructureNumber: this.StructureSearch,
				FacilityCarried: this.FacilityCarriedSearch,
				FeatureIntersected: this.FeatureIntersectedSearch,
				YearBuilt: this.YearBuiltSearch,
				Start: this.currentStart,
				PageSize: this.pageSize,
				StateAbbreviation: this.StateAbbreviation,
			};
			// perform the search
			this.pict.providers.BridgeProvider.performBridgeSearch(tmpFilters, (pError, pBridgeResults) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error rendering HeadlightPanels-Bridges-SearchResults: ${pError}`);
					this.pict.views.HeadlightPanels?.toast?.({
						message: `<strong>Error loading bridge search results:</strong><br/><em>${pError.message || pError}</em>`,
						type: 'is-danger',
					});
					return;
				}
				this.CurrentBridgeSearchResults = pBridgeResults;
				this.pict.views.HeadlightPaneBridges.renderAsync('HeadlightPanels-Bridges-SearchResults', '#BridgePanel-SearchResults-Container', null, null,
					(pError) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error rendering HeadlightPanels-Bridges-SearchResults: ${pError}`);
						}
						document.getElementById('BridgeSearch-SearchButton')?.classList?.remove('is-loading');
					});
			});
		});
	}

	/**
	 * This function is used to reset the search filters and reload the bridges from the lake.
	 * @return {boolean} - Always returns
	 */
	resetSearchFilters()
	{
		document.getElementById('BridgeSearch-SearchButton')?.classList?.add('is-loading');

		this.pict.ContentAssignment.assignContent('#BridgesSearchStructureNumber', '');
		this.pict.ContentAssignment.assignContent('#BridgesSearchFacilityCarried', '');
		this.pict.ContentAssignment.assignContent('#BridgesSearchYearBuilt', '');
		this.pict.ContentAssignment.assignContent('#BridgesSearchFeatureIntersected', '');
		this.pict.ContentAssignment.assignContent('#BridgesSearchCounty', '');

		this.StructureSearch = false;
		this.FacilityCarriedSearch = false;
		this.YearBuiltSearch = false;
		this.FeatureIntersectedSearch = false;
		this.CountySearch = false;

		this.currentStart = 0;

		this.loadBridgeData();

		return false;
	}

	/**
	 * This function is used to handle the selection of a bridge from the search results.
	 * @param {string} pIDBridge - The ID of the bridge that was selected
	 * @return {void}
	 */
	handleBridgeSelection(pIDBridge)
	{
		if (this.bridgeSelectionCallback)
		{
			if (this.CurrentBridgeSearchResults.length > 0)
			{
				const tmpBridge = this.CurrentBridgeSearchResults.find((pBridge) => pBridge.IDBridge == pIDBridge);
				this.bridgeSelectionCallback(tmpBridge);
				this.pict.views.HeadlightPanels.handlePanelToggle('Bridges', 'close');
			}
		}
	}

	/**
	 * This function is used to set the callback that is run when a bridge is selected from the search results.
	 * @param {BridgeSelectionCallback} fCallback - The callback function to run when a bridge is selected
	 * @return {void}
	 */
	setBridgeSelectionCallback(fCallback)
	{
		this.bridgeSelectionCallback = fCallback;
	}

	/**
	 * This function is used to handle the opening of the bridge panel from the advanced button.
	 * @param {Event} event - The event that triggered the opening of the bridge panel
	 */
	openBridgePanelFromAdvancedButton(event)
	{
		if (event && event.target instanceof HTMLElement)
		{
			event.preventDefault();
			// find the parent column of the advanced button
			const tmpParentColumn = event.target.closest('.column');
			// if the parent column exists
			if (tmpParentColumn)
			{
				this.fable.HeadlightPanels.applyUIHighlight(tmpParentColumn);
			}
		}
		this.pict.views.HeadlightPanels.handlePanelToggle('Bridges', 'open', () =>
		{
			this.pict.ContentAssignment.setAttribute('#HeadlightPanels-BridgesPanel', 'data-panel-mode', 'add-to-set');
		});
	}
}

module.exports = HeadlightPaneBridges;
// additional view-specific templates
const viewSpecificTemplates = [
	/* Bridge Search Templates - overrides to the default views */
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults',
		Template: /*html*/`
		<div id="HeadlightPanels-Bridges-SearchResults" class="container table-container">
			<table class="table is-striped is-hoverable is-fullwidth">
				<thead>
					<tr>
						<th>County</th>
						<th>Facility Carried</th>
						<th>Feature Intersected</th>
						<th class="has-text-right">Structure #</th>
						<th class="has-text-right">Year Built</th>
						{~T:HeadlightPanels-Bridges-SearchResults-Extra-Header~}
						{~T:HeadlightPanels-Bridges-SearchResults-Selection-Header~}
					</tr>
				</thead>
				<tbody id="HeadlightPanels-Bridges-ResultsEntries">
					{~TS:HeadlightPanels-Bridges-SearchResults-Row:Context[0].CurrentBridgeSearchResults~}
					{~TIfAbs:HeadlightPanels-Bridges-SearchResults-NoResults:Context[0]:Context[0].CurrentBridgeSearchResults.length^==^0~}
				</tbody>
			</table>
		</div>`,
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-Row',
		Template: /*html*/`
		<tr>
			<td>{~E:FIPSCounty^Record.IDFIPSCounty^HeadlightPanels-Bridges-SearchResults-County-Row-Cell~}</td>
			<td>{~D:Record.FacilityCarried~}</td>
			<td>{~D:Record.FeatureIntersected~}</td>
			<td class="has-text-right">{~D:Record.StructureNumber~}</td>
			<td class="has-text-right">{~D:Record.YearBuilt~}</td>
			{~T:HeadlightPanels-Bridges-SearchResults-Extra-Column:Record~}
			{~T:HeadlightPanels-Bridges-SearchResults-Selection-Column:Record~}
		</tr>`,
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-NoResults',
		Template: /*html*/`
		<tr>
			<td colspan="5" class="has-text-centered">
				<span class="icon">
					<i class="fa fa-fw fa-info-circle"></i>
				</span>
				<span class="icon-text">No results found</span>
			</td>
		</tr>`,
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-County-Row-Cell',
		Template: /*html*/`{~D:Record.Name~} {~D:Record.GUIDFIPSCounty~}`,
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-Selection-Header',
		Template: /*html*/`<th class="has-text-centered" data-panel-mode-show-if="add-to-set">Select</th>`,
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-Selection-Column',
		Template: /*html*/`
		<td class="has-text-centered is-vcentered" data-panel-mode-show-if="add-to-set">
			<button type="button" class="button p-0 is-ghost has-text-primary-75" onclick="_Pict.views.HeadlightPaneBridges.handleBridgeSelection('{~D:Record.IDBridge~}')">
				<span class="icon">
					<i class="fa fa-fw fa-lg fa-plus-circle"></i>
				</span>
			</button>
		</td>`,
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-Extra-Header',
		Template: /*html*/``, // This is intentionally blank
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-Extra-Column',
		Template: /*html*/``, // This is intentionally blank
	},
	{
		Hash: 'HeadlightPanels-Bridges-ActiveFilterCount',
		Template: /*html*/`{~D:Context[0].CurrentSearchFiltersCount~}`,
	},
];
// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];

const viewSpecificRenderables =
[
	{
		RenderableHash: 'HeadlightPanels-Bridges-SearchResults',
		TemplateHash: 'HeadlightPanels-Bridges-SearchResults',
		DestinationAddress: '#BridgePanel-SearchResults-Container',
	},
];

// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Renderables = [ ..._ViewConfiguration.Renderables, ...viewSpecificRenderables ];
module.exports.default_configuration = _ViewConfiguration;
